export const DEFAULT_FETCH_CONTACT_PARAMS = {
    sort: "name",
    searchField: "name",
    filters: {
        toJS: () => ({}),
    },
};

export const THRESHOLD_SUFFIX = "-threshold";
export const UI_FOLDER = "UI";
export const THRESHOLD_FOLDER = "UI-threshold";
export const STORAGE_PROMOTIONS_PAGE_DATA = "_managePromotionsPage";
export const SELECT_ALL = "selectAll";
export const PROMOTION_NAME_MAX_LENGTH = 150;
export const PROMOTION_DESCRIPTION_MAX_LENGTH = 250;
export const DEFAULT_PROMOTION_COUNT_TO_SHOW = 2;
export const DECIMALS_AND_DOTS = new RegExp(/[0-9.]/);
export const COMPANIES_LIMIT = 50;
export const DATE_FROM = "date_from";
export const DATE_TO = "date_to";
export const ELIGIBILITY_RULES = "eligibility_rules";
